
import { AttributEventMessage } from "./AttributEventMessage";

export class ArbetsorderAttributEventMessage extends AttributEventMessage {
    arbetsorderId: number;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "ArbetsorderAttributEventMessage";
    constructor($type) {
        super($type || ArbetsorderAttributEventMessage.$type);
    }
}

export enum ArbetsorderAttributGrupper {
    VirkesorderValidation = "Virkesorder.Validation",
    Viol3Validation = "Viol3.Validation"
}

export enum ArbetsorderAttributVirkesorderValidationNycklar {
    GenericMessages = "GenericMessages",
    KrontvagvalFelStatus = "KrontvagvalFelStatus"
}

export enum GenereicMessageSeverity {
    Info = 0,
    Warning = 1,
    Error = 2,
    Critical = 3
}
